import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import SignaturePad from "signature_pad";
import { mimeTypes } from "src/app/constants/mime-type";
import { HelperService } from "src/app/services/helper.service";

@Component({
    selector: 'mwp-signature',
    templateUrl: './signature.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SignatureComponent implements AfterViewInit,  OnInit {
    @ViewChild('vcSigPad', { static: true }) signaturePadElement: any;
    @ViewChild('clearSigButton', { static: true }) buttonRef!: ElementRef<HTMLButtonElement>;

    @Output() public emitCancel: EventEmitter<any> = new EventEmitter();
    @Output() public emitComplete: EventEmitter<Blob> = new EventEmitter();

    public signaturePad: SignaturePad;

    @HostListener('window:resize') onResize() {
        this.clearSignature();
    };

    constructor(
        private helperService: HelperService,
    ) {
    }

    ngOnInit(): void {
        this.signaturePad = new SignaturePad(this.signaturePadElement.nativeElement);
        this.signaturePad.addEventListener('endStroke', this.drawComplete);
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.buttonRef.nativeElement.click();    
        }, 500);
    }

    resizeCanvas() {
        const ratio =  Math.max(window.devicePixelRatio || 1, 1);
        const canvas = this.signaturePadElement.nativeElement;
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        canvas.getContext("2d").scale(ratio, ratio);
        this.signaturePad.clear(); // otherwise isEmpty() might return incorrect value
    }

    public drawComplete = (event: any): void => {
        const dataURI = this.signaturePadElement.nativeElement.toDataURL(mimeTypes["image/png"]);
        if (dataURI)
            this.emitComplete.emit(this.helperService.dataURItoBlob(dataURI));
    };

    public clearSignature(): void {
        this.resizeCanvas();
        this.emitCancel.emit();
    }
}